export default __webpack_public_path__ + "static/media/cp_geo_ni.d6158b8e.svg";